import { Component, Input, ViewChild } from '@angular/core';
import { Menu } from '../../models/menu.model';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent {
  @Input() items: Menu[];
  @ViewChild('childMenu') public childMenu;
}
